import request from "@/request/request-utils";

export default {
  // 返款申请
  refundApply: (params) => request.getAction("/api/HelpRefund/Apply", params),
  // 返款
  helpRefund: (data) => request.postData("/api/HelpRefund/Refund", data),
};
